import { ModalDialogCloseButton } from '@vp/swan'

import { useTranslations } from 'client/hooks/useTranslations'
import { SearchBox, PropTypes as SearchBoxPropTypes } from 'client/components/Gallery/Header/Searchbox'
import { useInView } from 'react-intersection-observer'

export interface PropTypes extends SearchBoxPropTypes {
  onClose: (event: React.MouseEvent<HTMLButtonElement>) => void
}

/**
 * Mobile Filter Menu
 * @param props
 */
export const FilterMenuHeader = ({ onClose, autoFocus }: PropTypes) => {
  const localize = useTranslations()
  const { ref: searchContainerRef, inView, entry } = useInView()
  const searchBoxIsVisible = inView || !entry

  return (
    <div className="filter-menu-header">
      <ModalDialogCloseButton accessibleText={localize('FilterMenuCloseButtonText')} className="filter-menu-header-close" onClick={onClose} />
      <div className="flyout-search-container" ref={searchContainerRef}>
        {searchBoxIsVisible && <SearchBox autoFocus={autoFocus} isMobile />}
      </div>
    </div>
  )
}

FilterMenuHeader.displayName = 'FilterMenuHeader'
